import { FC } from 'react';

import { geefNietGeaccepteerdeElementen, geefPerronSpoorVoorConflict } from '@/domain/conflict/conflictUtils';
import { Conflict } from '@/types/Conflicten';

import styles from './Conflicten.module.css';

type ConflictToelichtingProps = { conflict: Conflict; tooltip?: boolean };
const ConflictToelichting: FC<ConflictToelichtingProps> = ({ conflict, tooltip }) => {
  if (conflict.type === 'PERRONLENGTE') {
    return (
      <span className={!tooltip ? styles.toelichtingStyle : styles.toelichtingStyleTooltip}>
        {geefPerronSpoorVoorConflict(conflict)}
      </span>
    );
  }
  if (conflict.type !== 'VERKEERD_MATERIEEL') {
    return <span className={!tooltip ? styles.toelichtingStyle : styles.toelichtingStyleTooltip} />;
  }

  const [eersteNietGeaccepteerdElement] = geefNietGeaccepteerdeElementen(conflict);

  return (
    <span className={!tooltip ? styles.toelichtingStyle : styles.toelichtingStyleTooltip}>
      <span className={styles.toelichtingWrongStyle}>
        {!conflict.allElementsAccepted
          ? `${eersteNietGeaccepteerdElement?.materieelSoort}-${eersteNietGeaccepteerdElement?.materieelAanduiding}`
          : conflict.verkeerdMaterieelLaatsteElement}
      </span>
      &nbsp;
      <span>{`${conflict.eenheidSoort}-${conflict.eenheidAanduiding}`}</span>
    </span>
  );
};
export default ConflictToelichting;
